module.exports = __webpack_public_path__ + "img/shopping-retail.383da4b1.webp";